import { render } from "./SelectorWithTags.vue?vue&type=template&id=5e4a0020"
import script from "./SelectorWithTags.vue?vue&type=script&lang=js"
export * from "./SelectorWithTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__